import React from 'react'
import {BaseModal} from '../BaseModal/BaseModal'
import styles from './NoPermission.module.scss'
import {ReactComponent as Workforce} from '../../assets/Icons/Workforce.svg'
import {logout} from '../../utils'
import {WuButton} from '@npm-questionpro/wick-ui-lib'
import {useWt} from '@npm-questionpro/wick-ui-lib'
import {GLOBAL} from '../../Translation/English/global'
import {HOME} from '../../Translation/English/home'

export const NoPermissionWorkforce = (): React.JSX.Element => {
  const wt = useWt()

  return (
    <BaseModal
      visible={true}
      hideHeader={true}
      onCloseModal={() => {}}
      maxWidth="900px"
    >
      <div className={styles.noPermission}>
        <div className={styles.noPermissionHeader}>
          <p className={styles.noPermissionHeaderTitle}>
            {wt(HOME.upgradeTo)} <span>{wt(HOME.workforce)} </span>{' '}
            {wt(HOME.licenseToUnlock)}
          </p>
        </div>
        <div className={styles.noPermissionMain}>
          <div className={styles.noPermissionMainBlock1}>
            <h2 className={styles.noPermissionMainTitle}>
              {wt(GLOBAL.empower)}{' '}
            </h2>
            <p className={styles.noPermissionMainDescription}>
              {wt(HOME.noPermissionDescription)}
            </p>
            <div className={styles.noPermissionMainImg}>
              <Workforce />
            </div>
          </div>
          <div className={styles.noPermissionMainBlock2}>
            <h2 className={styles.noPermissionMainTitle}>
              {wt(HOME.workforce)}{' '}
            </h2>
            <p className={styles.noPermissionMainRequestPricing}>
              {wt(HOME.requestPricing)}
            </p>
            <p className={styles.noPermissionMainFeatures}>
              {wt(HOME.features)}{' '}
            </p>
            <ul>
              <li className={styles.noPermissionMainLi}>
                {wt(HOME.employeeSurveys)}
              </li>
              <li className={styles.noPermissionMainLi}>
                {wt(HOME['360feedback'])}
              </li>
              <li className={styles.noPermissionMainLi}>
                {wt(HOME.workforceAnalytics)}
              </li>
              <li className={styles.noPermissionMainLi}>{wt(HOME.support)}</li>
            </ul>

            <WuButton onClick={logout}>{wt(GLOBAL.logout)}</WuButton>
          </div>
        </div>
      </div>
    </BaseModal>
  )
}
